import { useState, useCallback } from 'react';

export const useNodeSelection = () => {
  const [nodes, setNodes] = useState([]);
  const [nodesLoading, setNodesLoading] = useState(false);
  const [selectedNode, setSelectedNode] = useState(null);

  const fetchAvailableNodes = useCallback(async () => {
    setNodesLoading(true);
    try {
      const response = await fetch('/api/v1/nodes/available');
      const data = await response.json();
      setNodes(data || []);
    } catch (error) {
      console.error('Failed to fetch available nodes:', error);
      setNodes([]);
    } finally {
      setNodesLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setSelectedNode(null);
  }, []);

  return {
    nodes,
    nodesLoading,
    selectedNode,
    setSelectedNode,
    fetchAvailableNodes,
    reset
  };
};